/*eslint-disable */
import React, { useEffect } from "react";
import { Button, Modal, Form as FormUi, Icon } from "semantic-ui-react";
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import CreatAxios from "../axiosComponent/create";
import { translate } from "react-i18next";
import { ERROR_MESSAGES, REQUIRED_FIELDS } from "../../utils/validationConstant";
import cogoToast from "cogo-toast";
import { MESSAGES } from "../../views/masters/skuType/skuTypeConstants";

function AddSKUType({ handleSubmit, t, touched, errors, values }) {
  const [open, setOpen] = React.useState(false);
  const [isProductCategoryTouched, setIsProductCategoryTouched] = React.useState(false);
  useEffect(() => {
    handleSubmit();
  }, [open]);
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button icon type="button">
          <Icon name="plus" />
        </Button>
      }
    >
      <Modal.Header>
        {t("add_new_sku.alt_title") || "Add New Product Type"}
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <FormUi.Group inline>
            <FormUi.Field width={2}>
              <label className="labelName">
                {t("add_new_sku.sku_type_code.title") || "Product Category Code"}
              </label>
            </FormUi.Field>
            <FormUi.Field
              width={4}
            >
              <Fieldmik
                type="text"
                className="ui input"
                name="serviceCategoryCode"
                placeholder={
                  t("add_new_sku.sku_type_code.placeholder") || "Code"
                }
                error={true ? true : false}

              />
              {/* {touched.skuTypeCode && errors.skuTypeCode ? (
                <div>
                  {t(
                    `add_new_sku.sku_type_code.error_msg.${errors.skuTypeCode}`
                  ) || errors.skuTypeCode}
                </div>
              ) : null} */}
            </FormUi.Field>
            <div className="mb-4"></div>
            <FormUi.Field width={2}></FormUi.Field>
            <FormUi.Field width={2}>
              <label className="labelName">
                {t("add_new_sku.sku_type_name.title") || "Product Category Name"}<span className="red"> *</span>
              </label>
            </FormUi.Field>
            <FormUi.Field
              width={4}
              error={touched.serviceCategory && errors.serviceCategory ? true : false}
            >
              <Fieldmik
                type="text"
                className="ui input"
                name="serviceCategory"
                placeholder={
                  t("add_new_sku.sku_type_name.placeholder") || "Name"
                }
                onFocus={() => setIsProductCategoryTouched(true)}
              />
              {touched.serviceCategory && errors.serviceCategory && isProductCategoryTouched? (
                <div className="error-msg-left">
                  {errors.serviceCategory}
                </div>
              ) : null}
            </FormUi.Field>
            <FormUi.Field width={2}></FormUi.Field>
            <FormUi.Field width={4} className='pt-3'>
              <label className="labelName">
                {t("add_new_sku.is_gst_exempted.title") || "Is GST Exempted"}
              </label>
            </FormUi.Field>
            <FormUi.Field
              width={2}
              //error={touched.skuTypeName && errors.skuTypeName ? true : false}
            >
              <Fieldmik
                type="checkbox"
                className="ui input"
                name="isGstExempted"
                // placeholder={
                //   t("add_new_sku.sku_type_name.placeholder") || "Name"
                // }
              />
              {/* {touched.skuTypeName && errors.skuTypeName ? (
                <div>
                  {t(
                    `add_new_sku.sku_type_name.error_msg.${errors.skuTypeName}`
                  ) || errors.skuTypeName}
                </div>
              ) : null} */}
            </FormUi.Field>
          </FormUi.Group>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" type="submit" onClick={() => setOpen(false)}>
          {t("add_new_sku.action_button.cancel") || "Cancel"}
        </Button>
        <Button
          content={t("add_new_sku.action_button.save") || "Save"}
          labelPosition="right"
          icon="checkmark"
          type="submit"
          onClick={() => {
            setIsProductCategoryTouched(true)
            if (!errors.serviceCategory){
              setOpen(false)
            }
          }}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}

const FormikAddSKUType = withFormik({
  validationSchema: yup.object({
    serviceCategory: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(30, ERROR_MESSAGES.MAX_LENGTH(30)),
  
  }),
  mapPropsToValues: (props) => {
    return {
      serviceCategoryCode: "",
      serviceCategory: "",
      isGstExempted: false,
    };
  },
  handleSubmit(values, { props, setFieldValue }) {
    CreatAxios({
      url: `service_category`,
      payload: {
        ...values,
      },
    })
      .then((res) => {
        cogoToast.success(res.data?.message || MESSAGES.addSuccess, { position: 'top-right' })
        props.getSKUList()
      })
      .catch((err) => {
        cogoToast.error(err.data?.message || MESSAGES.addFailure, { position: 'top-right' })
        console.log(err)
      });
  },
})(AddSKUType);

export default translate("sku")(FormikAddSKUType);
